import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'

// 上传图片
export function uploadFile(data) {
  return axios.request({
    url: urlObj.crm + 'crm/file/uploadFile',
    method: 'post',
    data
  })
}

// 查询商户信息
export function getTenantMessage(params) {
  return axios.request({
    // url: urlObj.wss + 'wss-system/tenantShop/getTenantMessage',
    url: urlObj.crm + 'crm/tenantManage/shop/info',
    method: 'get',
    params
  })
}

// 修改商户信息
export function updateTenantMessage(data) {
  return axios.request({
    url: urlObj.crm + 'crm/tenantManage/updateTenantMessage',
    method: 'post',
    data
  })
}

// 删除店铺照片
export function delimgs(params) {
  return axios.request({
    url: urlObj.crm + 'crm/tenantManage/images',
    method: 'delete',
    params
  })
}

// 编辑富文本
export function updatedesc(data) {
  return axios.request({
    url: urlObj.crm + 'crm/tenantManage/tenant/desc',
    method: 'post',
    data
  })
}

// 配件类型查询
export function listPartsType(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/listPartsType',
    method: 'get',
    params
  })
}

// 查询数据来源
export function getDictionariesItems(data) {
  return axios.request({
    url: urlObj.crm + 'crm/dictionariesItem/getDictionariesItems',
    method: 'post',
    data
  })
}

// 查询厂牌
export function listAllLabel(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/listAllLabel',
    method: 'get',
    params
  })
}

// 查询品牌
export function listAllBrand(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/listAllBrand',
    method: 'get',
    params
  })
}

// 查询配件销价
export function findSellPricePart(params, data) {
  return axios.request({
    url: urlObj.wss + 'wss-system/partSellPrice/findSellPricePart',
    method: 'post',
    params,
    data
  })
}
// 根据配件id查询配件
export function getById(partId) {
  return axios.request({
    url: `${urlObj.wss}wss-part/parts/getById/${partId}`,
    method: 'get'
  })
}

// 根据jiapeiPartId查询适用车型
export function listCarModeByPartId(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/listCarModeByPartId',
    method: 'get',
    params
  })
}

// 配件保存
export function save(data) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/save',
    method: 'post',
    data
  })
}

// 配件删除
export function delPart(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/delete',
    method: 'delete',
    params
  })
}

// 关联链
export function relation(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/listRelationByPartId',
    method: 'get',
    params
  })
}

// 替换链
export function replace(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/listReplaceByPartId',
    method: 'get',
    params
  })
}

// 根据jpid获取配件图片
export function getImgs(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/findImagelByPartId',
    method: 'get',
    params
  })
}

// 批量上传图片
export function setImgs(data, params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/imageUpload',
    method: 'post',
    data,
    params
  })
}

// 获取配件商品列表接口
export function getGoodsMessage(params, data) {
  return axios.request({
    // url: urlObj.wss + 'wss-system/tenantShop/getGoodsMessage',
    url: urlObj.wss + 'wss-system/tenantShop/getGoodsMessage',
    method: 'post',
    params,
    data
  })
}

// 修改/新增配件商品列表接口
export function updateGoodsMessage(data) {
  return axios.request({
    // url: urlObj.wss + 'wss-system/tenantShop/getGoodsMessage',
    url: urlObj.wss + 'wss-system/tenantShop/updateGoodsMessage',
    method: 'put',
    data
  })
}
